var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnersCommission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.739,
    height: 27.63,
    viewBox: "0 0 27.739 27.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5882",
    "data-name": "Group 5882",
    transform: "translate(6513.921 2007.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18004",
    "data-name": "Path 18004",
    d: "M390.739,160.369v6.217l-2.852-2.852a1.691,1.691,0,1,0-2.391,2.391l4.765,4.765v7.174h6.7V161.326L393.13,157.5h-4.107a20.2,20.2,0,0,1,.268,2.87Z",
    transform: "translate(-6883.138 -2157.867)",
    fill: "#85e6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18005",
    "data-name": "Path 18005",
    d: "M113.709,46.479l-1.857-1.857a2.643,2.643,0,0,1,3.419-4.011,19.333,19.333,0,0,0,.11-1.943,19.043,19.043,0,0,0-3.08-10.412L96.25,38.668,112.3,49.079a19.1,19.1,0,0,0,1.409-2.6Zm-9.089-9.724a.717.717,0,1,1-.717.717A.718.718,0,0,1,104.62,36.755Zm2.87,3.826a.717.717,0,1,1,.717-.717A.718.718,0,0,1,107.489,40.581Zm-3.217.781-.74-.606,4.3-5.261.74.606Z",
    transform: "translate(-6610.171 -2035.688)",
    fill: "#85e6c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersCommission);
export default __webpack_public_path__ + "static/media/partners_commission.574223ee9fe1ec4e60d8ce9cde4c8eb5.svg";
export { ForwardRef as ReactComponent };